import LTR from "@brand-icons/ploom/new-filter/new-filter-ltr.svg";
import RTL from "@brand-icons/ploom/new-filter/new-filter-rtl.svg";

import { iconFactory } from "../iconFactory";

export const NewFilterIcon = iconFactory("NewFilterIcon", LTR, RTL);
